import React, { useMemo } from 'react'
import MealIngredientCategoryForm from './_form'

export default function MealIngredientCategoryAdd (props) {
  const data = useMemo(() => ({ active: false }), [])
  return (
    <MealIngredientCategoryForm data={data} {...props} />
  )
}